// libs/util-testing/src/lib/mocks/handlers.ts
import { AuthMeV1OutputDto, IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { AUTH_API_PATHS } from '@quadminds/shared/commons';
import { PathParams, RequestHandler, rest, RestRequest } from 'msw';
import { legacyUserFixture, getLoginResponse, userFixture, verifyFakeJWToken } from './fixtures';
import { LoginResponse, RefreshTokenResponse } from '../types';

const RUNTIME_URL = process.env['NX_AUTH_API_URL'];

export const getMockedUserInfo = rest.get(`${RUNTIME_URL}/${AUTH_API_PATHS.V2.AUTH.ME}`, (req, res, ctx) => {
    return res(
        // Respond with a 200 status code
        ctx.status(200),
        ctx.json<IAuthMeV2OutputDto>(userFixture),
    );
});

export const getLegacyUserInfo = rest.get(`${RUNTIME_URL}/${AUTH_API_PATHS.V1.AUTH.ME}`, (req, res, ctx) => {
    return res(
        // Respond with a 200 status code
        ctx.status(200),
        ctx.json<AuthMeV1OutputDto>(legacyUserFixture),
    );
});

export const checkSession = rest.post(`${RUNTIME_URL}/${AUTH_API_PATHS.V1.AUTH.CHECK_SESSION}`, (req, res, ctx) => {
    return res(
        // Respond with a 200 status code
        ctx.status(200),
        ctx.json<LoginResponse>(getLoginResponse()),
    );
});

export const refreshToken = rest.get(`${RUNTIME_URL}/${AUTH_API_PATHS.V2.AUTH.REFRESH}`, (req, res, ctx) => {
    return res(
        // Respond with a 200 status code
        ctx.status(200),
        ctx.json<RefreshTokenResponse>(getLoginResponse()),
    );
});

export const logout = rest.post(`${RUNTIME_URL}/${AUTH_API_PATHS.V2.AUTH.LOGOUT}`, (req, res, ctx) => {
    return res(
        // Respond with a 200 status code
        ctx.status(200),
        ctx.json({}),
    );
});

export const selectOrganization = rest.patch(
    `${RUNTIME_URL}/${AUTH_API_PATHS.V2.AUTH.SELECT_ORGANIZATION}`,
    (req, res, ctx) => {
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json({
                accessToken: 'some-token',
                refreshToken: 'refresh-token',
            }),
        );
    },
);

export const handlers: RequestHandler[] = [
    getMockedUserInfo,
    getLegacyUserInfo,
    checkSession,
    refreshToken,
    logout,
    selectOrganization,
];

export const handlersWithErrors = {
    checkSession: rest.post(`${RUNTIME_URL}/${AUTH_API_PATHS.V1.AUTH.CHECK_SESSION}`, (_, res, ctx) => {
        return res(ctx.status(401), ctx.json({}));
    }),
    refreshToken: rest.get(`${RUNTIME_URL}/${AUTH_API_PATHS.V2.AUTH.REFRESH}`, (_, res, ctx) => {
        return res(ctx.status(401), ctx.json({}));
    }),
};

export function handleFakeTokenVerify(req: RestRequest<any, PathParams<any>>): boolean {
    const auth = req.headers.get('Authorization');

    const [type, token] = auth?.split(' ') ?? [];
    if (type !== 'Bearer') return false;

    if (!verifyFakeJWToken(token)) {
        return false;
    }

    return true;
}
